import { JsonRestApiRequestConfig, makeJsonRestApiRequest } from '~src/httpClient/RestApiService';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';

import { IScimConfiguration } from '../../services/ScimConfigurationsService';

export interface IGetScimConfigurations extends IResult {
    scimConfigurations: {
        scimConfiguration: IScimConfiguration[];
    };
}



export function getScimConfigurationRequestConfig(): JsonRestApiRequestConfig {
  return {
    restApiVersion: '3.26',
    httpMethod: 'GET',
    endpoint: `scimConfigurations`,
    serverWideRequest: false
  };
}



export function callGetAllScimConfigurationsRequest(): Promise<IGetScimConfigurations> {
  return makeJsonRestApiRequest<void, IGetScimConfigurations>({
    config: getScimConfigurationRequestConfig(),
    request: null
  });
}